import { render, staticRenderFns } from "./news-add-or-update.vue?vue&type=template&id=2946ab27"
import script from "./news-add-or-update.vue?vue&type=script&lang=js"
export * from "./news-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports